import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

class ModGalleryAnimation {
  constructor(el) {
    this.$el = $(el)
    this.$galleries = this.$el.find('.partner-logos__grid')
    this.speed = 0.5
    this.splides = []
    this.rtl = this.$el.data('rtl')
  }

  init() {
    this.initializeSliders()
  }

  initializeSliders() {
    this.$galleries.each((_index, gallery) => {
      const windowWidth = window.innerWidth;
      const gapSize = windowWidth >= 768 ? '24px' : '12px';

      let scrollSpeed;
      if (this.rtl) {
        scrollSpeed = this.speed
      } else {
        scrollSpeed = -this.speed
      }

      const splideConfig = {
        type: 'loop',
        direction: 'ltr',
        drag: false,
        arrows: false,
        pagination: false,
        autoWidth: true,
        perPage: 1,
        gap: gapSize,
        autoScroll: {
          speed: scrollSpeed,
          pauseOnHover: false,
          rewind: false,
        },
      }

      const splide = new Splide(gallery, splideConfig);

      if (this.rtl) {
        $(gallery).closest('.partner-logos__grid-wrapper').addClass('is-rtl');
      }

      splide.mount({ AutoScroll });
      this.splides.push(splide);
    })
  }
}

export default (() => {
  const $el = $('.partner-logos')
  $el.each((_, elm) => {
    new ModGalleryAnimation(elm).init()
  })
})()